import { useMemo } from 'react';

import type { Margin } from 'recharts/types/util/types';

import type { ChartData } from '../types/chart';
import { HouseHoldIncomeAgeCharts } from './household-income-age-chart';
import { HouseHoldStructureCharts } from './household-structure-chart';
import { PopulationSizeChart } from './population-size-chart';

export const DynamicChartRenderer = ({
  activeTab,
  chartData,
  height = 220,
  fontSize = 12,
  barSize = 28,
  margin = { top: 20, right: 30, left: 200, bottom: 0 },
}: {
  activeTab: string;
  chartData: ChartData;
  height: number;
  fontSize?: number;
  barSize?: number;
  margin?: Margin;
}) => {
  const renderedChart = useMemo(() => {
    switch (activeTab) {
      case 'household_buying_power':
      case 'income_levels':
      case 'age_groups':
        return (
          <HouseHoldIncomeAgeCharts
            chartData={chartData}
            height={height}
            fontSize={fontSize}
            barSize={barSize}
            margin={margin}
          />
        );

      case 'household_structure':
        return (
          <HouseHoldStructureCharts
            chartData={chartData}
            height={height}
            fontSize={fontSize}
            margin={margin}
          />
        );

      case 'population_size':
        return <PopulationSizeChart chartData={chartData} height={height} fontSize={fontSize} />;
      default:
        return null;
    }
  }, [activeTab, chartData, height, fontSize, barSize, margin]);

  return renderedChart;
};
